import { render, staticRenderFns } from "./editprofile.vue?vue&type=template&id=4f651cf5"
import script from "./editprofile.vue?vue&type=script&lang=js"
export * from "./editprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports